import React, { Fragment, useState, useEffect } from "react";
import Alert from "../../layout/Alert";
import DeviceFactoryFirmware from "./FactoryFirmware";
import DeviceFotaFirmware from "./FotaFirmware";
import FirmwareDistribution from "./FirmwareDistribution";
import "./DeviceFirmware.css";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { Box } from "@mui/material";
import ResponsiveContentWrapper from "../../layout/ResponsiveContentWrapper";

const DeviceFirmware = ({
    wrapperClass,
}) => {

    const [activeTab, setActiveTab] = React.useState(0)

    return (<Fragment>
        <ResponsiveContentWrapper className={wrapperClass || ""}>
            <Alert />

            <Box className="row" sx={{ width: "100%", minWidth: 0 }}>
                <Tabs
                    value={activeTab}
                    onChange={(e, newValue) => {
                        setActiveTab(newValue)
                    }}
                    variant="scrollable"
                    scrollButtons="auto"
                    TabIndicatorProps={{
                        style: {
                            backgroundColor: "#000"
                        }
                    }}
                >
                    <Tab label="Firmware Distribution" />
                    <Tab label="Factory Firmware" />
                    <Tab label="FOTA Firmware" />
                </Tabs>
                <div hidden={activeTab !== 0}>
                    <FirmwareDistribution></FirmwareDistribution>
                </div>
                <div hidden={activeTab !== 1}>
                    <DeviceFactoryFirmware></DeviceFactoryFirmware>
                </div>
                <div hidden={activeTab !== 2}>
                    <DeviceFotaFirmware></DeviceFotaFirmware>
                </div>
            </Box>
        </ResponsiveContentWrapper>

    </Fragment>
    );
}

export default DeviceFirmware

